// extracted by mini-css-extract-plugin
export default {"tab_panel_hidden":"JFCnv4HVPoxz74zqqJRY","tabPanelHidden":"JFCnv4HVPoxz74zqqJRY"};